import React, {useEffect, useState, useRef} from 'react';
import styled from "styled-components";

import useFetch from "../Utilities/API/useFetch.react";
import Breakdown from "../Components/Transactions/Enterprise/Breakdown.react";
import JournalEntry from "../Components/Transactions/Enterprise/JournalEntry.react";
import CustomerBreakdown from "../Components/Transactions/Enterprise/CustomerBreakdown.react";
import {Icon} from "react-materialize";
import {findJournalEntry} from "./EnterpriseTransactions.react";

const StyledPage = styled.div`
  background-color: #EFEFEF;
  .top-section {
    padding-top: 15px;
    background: linear-gradient(135deg,#0f82c5,#07bb9c);
    height: 108vh;
    color: white;
    padding-left: 3rem;
    padding-right: 3rem;
    
    .header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;

      .customer-id {
        display: flex;
        .copy-text {
          text-align: right;
          width: 40rem;
          font-size: 2rem;
          height: 2.3rem;
          background-color: transparent;
          color: white;
          &:focus {
            outline: none;
          }
      }
      
        .copy-icon {
          padding-left: .5rem;
          cursor: grab;
        }
        
        textarea {
          resize: none;
        }
      }
    }
  }
`

const TransactionDetails = () => {
  const textAreaRef = useRef(null);
  const [transaction, setTransaction] = useState(null);
  const [error, setError] = useState(null);
  const [fetchUrl] = useFetch();

  const fetchTransactionDetails = async () => {
    let pathName = window.location.pathname
    const transactionId = /[^=]*$/.exec(pathName)[0];
    let foundTransaction = await findJournalEntry(transactionId);
    setTransaction(transactionId);
    setTransaction(foundTransaction);
  }

  useEffect(() => {
    fetchTransactionDetails();
  }, [])

  const handleCopy = () => {
    //todo: Make this a hook
    textAreaRef.current.select();
    document.execCommand("copy")
  }

  const fakeCustomerId = '5457083d-5157-436c-918c-a8e8a701c98c';
  return (
    <StyledPage smaller={false}>
      <div className={'top-section'}>
        <div className={'header'}>
          <h1>Transaction Details</h1>
          <div className={'customer-id'}>
            <textarea readOnly={true} className={'copy-text'} ref={textAreaRef} value={fakeCustomerId}/>
            <div value={fakeCustomerId} onClick={handleCopy} className={'copy-icon'}>
              <Icon>content_copy</Icon>
            </div>
          </div>
        </div>
        {transaction && <Breakdown transaction={transaction} />}
        {transaction && <JournalEntry transaction={transaction} />}
      </div>
      {/*{!transaction.enterprise && <CustomerBreakdown />}*/}
    </StyledPage>
  )
}

export default TransactionDetails;